import questionWhite from "@/assets/images/question-white.svg";

type FAQButtonPros = {
  onClick: () => void;
};

export default function FAQButton({ ...props }: FAQButtonPros) {
  return (
    <div className="cursor-pointer flex flex-row justify-center p-6 gap-4 w-32 h-32 bottom-16 right-12 bg-[var(--redContinente)] rounded-full my-0 ml-auto shadow-xl" onClick={props.onClick}>
      <img src={questionWhite} alt="question-mark" />
    </div>
  );
}
